import { HeightProps, WidthProps } from 'styled-system';

import { convertPropsToStyle } from './properties';

const HEIGHT_PROPS = ['height', 'maxHeight', 'minHeight'];
const WIDTH_PROPS = ['width', 'maxWidth', 'minWidth'];

/**
 * Position related styles for styled components
 *
 * @param props - render props
 */
export const height = convertPropsToStyle<HeightProps>(HEIGHT_PROPS);
export const width = convertPropsToStyle<WidthProps>(WIDTH_PROPS);
